export enum BarChartType {
  Standard = 'standard',
  Normalized = 'normalized',
  Stacked = 'stacked'
}
